import request from '_utils/request'

export function listspecial(data) {
    return request({
      url: '/web_api/special/columnZt/list',
      method: 'post',
      data: data
    })
  }
  export function imgList(data) {
    return request({
      url: '/web_api/special/workZt/list',
      method: 'post',
      data: data
    })
  }
  export function infospecial(data) {
    return request({
      url: '/web_api/special/columnZt/'+data,
      method: 'get',
    })
  }